<div class="company-overview">
  <table>
    <tbody>
      <!-- actions -->
      <tr>
        <td colspan="3">
          <div class="company-actions">
            <button (click)="openControlPanel(company, ENV.PRODUCTION)" class="vox-btn btn btn-success" translate>
              companies.table.actions.prod-controlpanel
            </button>
            <button (click)="openControlPanel(company, ENV.STAGING)" class="vox-btn btn btn-warning" translate>
              companies.table.actions.staging-controlpanel
            </button>
            <button *ngIf="canWipLogin" class="vox-btn btn btn-info login-wip" (click)="openWipLoginPopup()">
              <i class="fa fa-wrench"></i>
            </button>
            <ngx-skeleton-loader *ngIf="company.deleting"
              [theme]="{'margin-bottom': '-3px', 'width': '180px', 'height':'34px'}"></ngx-skeleton-loader>
            <button *ngIf="!company.deleting" [disabled]="!company.locked || company.readOnly"
              (click)="deleteCompany(company)" class="vox-btn btn btn-danger">
              <span translate>companies.table.actions.delete</span>
              <i *ngIf="!company.locked" container="body"
                [ngbTooltip]="'companies.table.actions.delete-info' | translate" class="icon-small-info"></i>
            </button>
          </div>
        </td>
      </tr>
      <!-- end actions -->
      <!-- name  -->
      <tr *ngIf="loadingData.company">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.company">
        <td class="property" translate>company.overview.name</td>
        <td *ngIf="!editing" class="value">{{company.name}}</td>
        <td *ngIf="editing" class="value">
          <div class="vox-input-group vox-input-group_dense">
            <input [formControl]="newNameInput" class="vox-text-field" name="new-name" type="text" />
          </div>
        </td>
        <td class="action">
          <button *ngIf="!editing" (click)="editing = true;" class="vox-btn btn btn-success"
            [disabled]="company.readOnly" translate>common.edit</button>
          <ng-container *ngIf="editing" class="rename-company-actions">
            <button [disabled]="(newNameInput.pristine || newNameInput.invalid) || company.readOnly"
              (click)="saveName()" class="vox-btn btn btn-success" translate>
              common.save
            </button>
            <button (click)="editing = false" class="vox-btn btn btn-danger" [disabled]="company.readOnly" translate>
              confirmation.cancel
            </button>
          </ng-container>
        </td>
      </tr>
      <!-- end name  -->
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.alphaname.title</td>
        <td class="value">{{company.alphaname}}</td>
        <td class="action"><button class="vox-btn vox-btn__copy btn-info" (click)="onCopyChurnLink()"
            [disabled]="!subscription" translate><i class="fa fa-clone mr-1"
              aria-hidden="true"></i>company.overview.alphaname.actions.churn-link</button>
        </td>
      </tr>
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.support-type.label</td>
        <td class="value">
          <span class="vox-chip" [ngClass]="showVipLabel ? 'vox-chip_aquamarine' : 'vox-chip_bright-crimson-text'"
            translate>
            {{ showVipLabel ? 'company.overview.support-type.vip' : 'company.overview.support-type.standard' }}
          </span>
        </td>
        <td class="action"></td>
      </tr>
      <tr>
        <td class="property" translate>company.overview.email</td>
        <td class="value"><a href="mailto:{{company.email}}">{{company.email}}</a></td>
        <td class="action"></td>
      </tr>
      <tr *ngIf="loadingData.chatInfo">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.chatInfo">
        <td class="property">Voxloud Chat</td>
        <td *ngIf="companyChatInfo" class="value">
          <div><b class="mr-1">Name: </b>{{companyChatInfo.name || '-'}}</div>
          <div><b class="mr-1">Email ID: </b>{{companyChatInfo.email_id || '-'}}</div>
        </td>
        <td *ngIf="!companyChatInfo" class="value">-</td>
        <td class="action"></td>
      </tr>
      <!-- subscription info -->
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.subscription-info.title</td>
        <td *ngIf="subscription" class="value subscription" colspan="2">
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.status.title</b>
            <span translate>company.overview.subscription-info.status.{{subscription.status}}</span>
          </div>
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.plan-name</b>{{subscription.plan.name}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.plan-id</b>{{subscription.plan.id}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.users</b>{{subscription.plan.quantity}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.mrr</b>{{subscription.monthly_total_cost | countryCurrency: subscription.currency_code:'symbol':'1.1-3':locale}}
          </div>
          <div>
            <b class="mr-1"
              translate>company.overview.subscription-info.activation-date</b>{{subscription.activation_date | date:
            'medium': undefined: locale}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.subscription-info.creation-date</b>{{subscription.creation_date |
            date: 'medium': undefined: locale}}
          </div>
          <div>
            <b class="mr-1"
              translate>company.overview.subscription-info.billing-date</b>{{subscription.next_billing_date | date:
            'medium': undefined: locale}}
          </div>
          <div>
            <b class="mr-1"
              translate>company.overview.subscription-info.due-invoices</b>{{subscription.due_invoices_count}}
          </div>
          <div>
            <b class="mr-1"
              translate>company.overview.subscription-info.chargebee-id</b>{{subscription.chargebee_customer_id}}
          </div>
        </td>
        <td *ngIf="!subscription"> - </td>
        <td *ngIf="!subscription"></td>
      </tr>
      <!-- end subscription info -->
      <!-- addons info -->
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.addons</td>
        <td class="value addons" colspan="2" *ngIf="subscription?.addons.length > 0">
          <ul class="addons">
            <li *ngFor="let addon of subscription?.addons;">
              <span class="quantity">{{addon.quantity}} ×</span>
              {{addon.name}}
            </li>
          </ul>
        </td>
        <td *ngIf="subscription?.addons.length === 0 || !subscription?.addons"> - </td>
        <td *ngIf="subscription?.addons.length === 0 || !subscription?.addons"></td>
      </tr>
      <!-- end addons info -->
      <!-- billing info -->
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.billing-info.title</td>
        <td *ngIf="billingInfo" class="value">
          <div>
            <b class="mr-1" translate>company.overview.billing-info.address</b>{{billingInfo.address_line_1}}
          </div>
          <div>
            {{billingInfo.zip}} - {{billingInfo.city}}({{billingInfo.country}})
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.tax-id</b>{{company.taxId}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.invoincing-email</b>
            <span *ngFor="let email of billingInfo.invoicing_emails; let i=index">
              <a href="mailto:{{email}}">
                {{email}}</a>
              <span *ngIf="i+1 !== billingInfo.invoicing_emails.length">, </span>
            </span>
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.category</b>{{businessCategoryAndType.category.name}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.type</b>{{businessCategoryAndType.type.name}}
          </div>
        </td>
        <td *ngIf="!billingInfo" class="value">
          <div>
            <b class="mr-1" translate>company.overview.billing-info.address</b>{{billingInfo.address_line_1}}
          </div>
          <div>
            {{billingInfo.zip}} - {{billingInfo.city}}({{billingInfo.country}})
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.tax-id</b>{{company.taxId}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.billing-info.invoincing-email</b>-
          </div>
        </td>
        <td class="action"></td>
      </tr>
      <!-- end billing info -->
      <!-- balance info -->
      <tr *ngIf="loadingData.subscription">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.subscription">
        <td class="property" translate>company.overview.balance-info.title</td>
        <td *ngIf="balanceInfo" class="value">
          <div>
            <b class="mr-1" translate>company.overview.balance-info.type</b>
            <div class="vox-chip vox-chip_royal-blue-text">{{balanceInfo.bundle_type}}</div>
          </div>
          <div>
            <b class="mr-1" translate>company.overview.balance-info.name</b>{{balanceInfo.bundle_name | noUnderscore}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.balance-info.minutes</b>{{balanceInfo.bundle_minutes}} &times; {{balanceInfo.bundle_multiplier}} = {{balanceInfo.bundle_minutes * balanceInfo.bundle_multiplier}}
          </div>
          <div>
            <b class="mr-1" translate>company.overview.balance-info.available</b>{{balanceInfo.value}}
          </div>
        </td>
        <td class="value" *ngIf="!balanceInfo">-</td>
        <td class="action"></td>
      </tr>
      <!-- end balance info -->
      <!-- payment info -->
      <tr *ngIf="loadingData.paymentInfo">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.paymentInfo">
        <td class="property" translate>company.overview.payment-info.title</td>
        <td *ngIf="paymentInfo" class="value">
          <ng-container *ngIf="paymentInfo.type === 'card'">
            <div>
              <span class="font-weight-bold">{{paymentInfo.brand}}</span>
            </div>
            <div>
              {{paymentInfo.masked_number}} {{paymentInfo.expiry_month}}/{{paymentInfo.expiry_year}}
            </div>
            <div class="vox-chip vox-chip_royal-blue-text">{{paymentInfo.status}}</div>
          </ng-container>
          <ng-container *ngIf="paymentInfo.type === 'sepa_direct_debit'">
            <div>
              <span class="font-weight-bold" translate>company.overview.payment-info.sepa</span>
            </div>
            <div>
              {{paymentInfo.name_on_account}} ***************{{paymentInfo.last_four_digits}}
            </div>
            <div class="vox-chip vox-chip_royal-blue-text">{{paymentInfo.status}}</div>
          </ng-container>
          <ng-container *ngIf="paymentInfo.type === 'BankTransferDto'"> - </ng-container>
        </td>
        <td *ngIf="!paymentInfo"> - </td>
        <td class="action">
          <button [disabled]="company.readOnly" (click)="openGenerateUpdatePaymentLinkModal()"
            class="vox-btn btn btn-success" translate>company.overview.generate-update-payment-link.button</button>
        </td>
      </tr>
      <!-- end payment info -->
      <!-- partner data -->
      <tr *ngIf="loadingData.partner">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.partner">
        <td class="property" translate>company.overview.partner.title</td>
        <td class="value">
          <ng-container *ngIf="!partnerData">
            <div class="vox-chip vox-chip_bright-crimson-text" translate>company.overview.partner.no-partner</div>
          </ng-container>
          <ng-container *ngIf="partnerData">
            <div class="vox-chip vox-chip_royal-blue-text" translate>company.overview.partner.partner</div>
            <div>
              <b class="mr-1" translate>company.overview.partner.name</b>{{partnerData.partner.name}}
            </div>
            <div>
              <b class="mr-1" translate>company.overview.partner.email</b>
              <a href="mailto:{{partnerData?.partner.email}}">
                {{partnerData.partner.email}}</a>
            </div>
          </ng-container>
        </td>
        <td class="action"></td>
      </tr>
      <!-- end partner data -->
      <!-- hubspot deal -->
      <tr *ngIf="loadingData.addtionalData || loadingData.updateHubspot">
        <td colspan="3">
          <ngx-skeleton-loader count="3" [theme]="{'height': '22px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.addtionalData && !loadingData.updateHubspot">
        <td class="property" translate>hubspot.label</td>
        <td class="value text-left" *ngIf="!setHubspot && additionalCompanyData?.hubspot_data">
          <div>
            <b class="mr-1" translate>hubspot.deal_id</b> {{ additionalCompanyData.hubspot_data.deal_id }}
          </div>
          <div>
            <b class="mr-1" translate>hubspot.owner_id</b> {{ additionalCompanyData.hubspot_data.deal_owner_id }}
          </div>
          <div>
            <b class="mr-1" translate>hubspot.owner_name</b> {{ additionalCompanyData.hubspot_data.deal_owner_name }}
          </div>
        </td>
        <td *ngIf="setHubspot" class="value">
          <div class="vox-input-group vox-input-group_dense">
            <input class="vox-text-field" [formControl]="dealIdInput" placeholder="Set deal id" name="new-name"
              type="number" />
          </div>
        </td>
        <td class="action" colspan="2">
          <div *ngIf="!additionalCompanyData?.hubspot_data">
            <button [disabled]="company.readOnly" *ngIf="!setHubspot" (click)="setHubspot = true;"
              class="vox-btn btn btn-success" translate>common.set_deal</button>
            <ng-container *ngIf="setHubspot" class="rename-company-actions">
              <button (click)="setDealId()" class="vox-btn btn btn-success" translate [disabled]="dealIdInput.invalid">
                common.save
              </button>
              <button (click)="setHubspot = false" class="vox-btn btn btn-danger" translate>
                confirmation.cancel
              </button>
            </ng-container>
          </div>
        </td>
      </tr>
      <!-- hubspot deal end-->
      <!-- toggle anti fraud mode-->
      <tr>
        <td class="property" translate>company.overview.anti-fraud</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle [loading]="loadingData.antifraudLock" [toggleOn]="fraudLocked" [config]="{isAquamarine: true}"
            (toggleOnChange)="toggleAntifraudLock($event)">
          </vox-toggle>
        </td>
      </tr>
      <!-- end anti fraud toggle mode-->
      <!-- toggle read only mode -->
      <tr>
        <td class="property" translate>company.overview.read-only</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle [loading]="loadingData.readOnlyMode" [toggleOn]="company.readOnly" [config]="{isAquamarine: true}"
            (toggleOnChange)="toggleReadOnly($event)">
          </vox-toggle>
        </td>
      </tr>
      <!-- end read only mode  -->
      <!-- lock/unlock  -->
      <tr>
        <td class="property" translate>company.overview.locked</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle placement="left" [disableTooltip]="!isDisabledLock(company)" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="company.locking" [toggleOn]="company.locked" [config]="{isAquamarine: true, disabled: isDisabledLock(company)}"
          (toggleOnChange)="toggleLock()">
        </vox-toggle>
        </td>
      </tr>
      <!-- end lock/unlock  -->
      <!-- administrative notes -->
      <tr *ngIf="loadingData.addtionalData">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '300px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.addtionalData">
        <td class="property" translate>company.overview.notes.administration.title</td>
        <td class="value">
          <pre [ngClass]="{
            'vox-card': true,
            'empty': isNotesEmpty(NOTE_TYPES.administration)
            }">{{
                 additionalCompanyData?.notes_administration
                 ? additionalCompanyData?.notes_administration
                 : 'company.overview.notes.administration.not' | translate
               }}</pre>
        </td>
        <td class="action">
          <button class="vox-btn btn btn-success"
            [disabled]="company.readOnly || isNotesEmpty(NOTE_TYPES.administration)"
            (click)="openNotesPopup('view', NOTE_TYPES.administration)" translate>
            company.overview.notes.view
          </button>
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || !additionalCompanyData"
            (click)="openNotesPopup('edit', NOTE_TYPES.administration)" translate>
            company.overview.notes.edit
          </button>
        </td>
      </tr>
      <!-- end administrative notes -->
      <!-- sales notes -->
      <tr *ngIf="loadingData.addtionalData">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '300px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.addtionalData">
        <td class="property" translate>company.overview.notes.sales.title</td>
        <td class="value">
          <pre [ngClass]="{
            'vox-card': true,
            'empty': isNotesEmpty(NOTE_TYPES.sales)
            }">{{
                 additionalCompanyData?.notes_sales
                 ? additionalCompanyData?.notes_sales
                 : 'company.overview.notes.sales.not' | translate
               }}</pre>
        </td>
        <td class="action">
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || isNotesEmpty(NOTE_TYPES.sales)"
            (click)="openNotesPopup('view', NOTE_TYPES.sales)" translate>
            company.overview.notes.view
          </button>
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || !additionalCompanyData"
            (click)="openNotesPopup('edit', NOTE_TYPES.sales)" translate>
            company.overview.notes.edit
          </button>
        </td>
      </tr>
      <!-- end sales notes -->
      <!-- success notes -->
      <tr *ngIf="loadingData.addtionalData">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '300px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.addtionalData">
        <td class="property property--note" translate>company.overview.notes.success.title</td>
        <td class="value">
          <pre [ngClass]="{
            'vox-card': true,
            'empty': isNotesEmpty(NOTE_TYPES.success)
            }">{{
                 additionalCompanyData?.notes_success
                 ? additionalCompanyData?.notes_success
                 : 'company.overview.notes.success.not' | translate
            }}</pre>
        </td>
        <td class="action">
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || isNotesEmpty(NOTE_TYPES.success)"
            (click)="openNotesPopup('view', NOTE_TYPES.success)" translate>
            company.overview.notes.view
          </button>
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || !additionalCompanyData"
            (click)="openNotesPopup('edit', NOTE_TYPES.success)" translate>
            company.overview.notes.edit
          </button>
        </td>
      </tr>
      <!-- end success notes -->
      <!-- support notes -->
      <tr *ngIf="loadingData.addtionalData">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{'height': '300px', 'margin-bottom': 0}"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loadingData.addtionalData">
        <td class="property property--note" translate>company.overview.notes.support.title</td>
        <td class="value">
          <pre [ngClass]="{
            'vox-card': true,
            'empty': isNotesEmpty(NOTE_TYPES.support)
            }">{{
                 additionalCompanyData?.notes_support
                 ? additionalCompanyData?.notes_support
                 : 'company.overview.notes.support.not' | translate
             }}</pre>
        </td>
        <td class="action">
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || isNotesEmpty(NOTE_TYPES.support)"
            (click)="openNotesPopup('view', NOTE_TYPES.support)" translate>
            company.overview.notes.view
          </button>
          <button class="vox-btn btn btn-success" [disabled]="company.readOnly || !additionalCompanyData"
            (click)="openNotesPopup('edit', NOTE_TYPES.support)" translate>
            company.overview.notes.edit
          </button>
        </td>
      </tr>
      <!-- end support notes -->
      <!-- recordings  -->
      <tr>
        <td class="property" translate>company.overview.has-recordings.title</td>
        <td class="value"></td>
        <td class="action pt-1 pb-1">
          <div class="recording-actions">
            <label class="recording-actions-label" translate>company.overview.has-recordings.outbound</label>
            <vox-toggle [loading]="loadingData.recordings?.outbound_enabled" [toggleOn]="callRecordingConfiguration?.outbound_enabled" [config]="{isAquamarine: true}"
              (toggleOnChange)="toggleRecordings('outbound_enabled', $event)">
            </vox-toggle>
          </div>
          <div class="recording-actions">
            <label class="recording-actions-label" translate>company.overview.has-recordings.inbound</label>
            <vox-toggle [loading]="loadingData.recordings?.inbound_enabled" [toggleOn]="callRecordingConfiguration?.inbound_enabled" [config]="{isAquamarine: true}"
              (toggleOnChange)="toggleRecordings('inbound_enabled', $event)">
            </vox-toggle>
          </div>
          <div class="recording-actions">
            <label class="recording-actions-label" translate>company.overview.has-recordings.internal</label>
            <vox-toggle [loading]="loadingData.recordings?.internal_enabled" [toggleOn]="callRecordingConfiguration?.internal_enabled" [config]="{isAquamarine: true}"
              (toggleOnChange)="toggleRecordings('internal_enabled', $event)">
            </vox-toggle>
          </div>
        </td>
      </tr>
      <!-- end recordings  -->
      <!-- pivot  -->
      <tr>
        <td class="property" translate>company.overview.has-pivot</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle placement="left" [disableTooltip]="!company.readOnly && hasPivot !== undefined && !isPivotDisabled" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loadingData.pivot" [toggleOn]="hasPivot" [config]="{isAquamarine: true, disabled: company.readOnly || hasPivot === undefined || isPivotDisabled}"
          (toggleOnChange)="togglePivot()">
        </vox-toggle>
        </td>
      </tr>
      <!-- end pivot  -->
      <!-- start channels limit -->
      <tr>
        <td class="property" translate>company.overview.channel-info.title</td>
        <td class="value">
          <div>
            <b class="mr-1" translate>company.overview.channel-info.call-limit</b>{{callLimit}}
          </div>
        </td>
        <td class="action text-right">
          <label class="channel-actions-title" translate>company.overview.channel-info.notifications</label>
          <div class="channel-actions">
            <label class="channel-actions-label" translate>company.overview.channel-info.general</label>
            <vox-toggle placement="left" [disableTooltip]="!company.readOnly && channelGeneralNotificationsEnabled !== undefined" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loadingData.channelInfo.general" [toggleOn]="channelGeneralNotificationsEnabled" [config]="{isAquamarine: true, disabled: company.readOnly || channelGeneralNotificationsEnabled === undefined}"
            (toggleOnChange)="toggleChannelLimitGeneralNotifications($event)">
            </vox-toggle>
          </div>
          <div class="channel-actions">
            <label class="channel-actions-label" translate>company.overview.channel-info.internal</label>
            <vox-toggle placement="left" [disableTooltip]="!company.readOnly && channelLimitSlackInternalMessageEnabled !== undefined" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loadingData.channelInfo.internal" [toggleOn]="channelLimitSlackInternalMessageEnabled" [config]="{isAquamarine: true, disabled: company.readOnly || channelLimitSlackInternalMessageEnabled === undefined}"
            (toggleOnChange)="toggleChannelLimitInternalNotifications($event)">
            </vox-toggle>
          </div>
        </td>
      </tr>
      <!-- end channels limit -->
      <!-- credit  -->
      <ng-container *ngIf="loadingData.credit">
        <tr>
          <td colspan="3">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!loadingData.credit">
        <tr>
          <td class="property" translate>company.overview.balance</td>
          <td *ngIf="company.balance === 0 || company.balance" class="value">{{company.balance |
            currency:'EUR':'symbol':'1.0':'it-IT'}}</td>
          <td *ngIf="company.balance !== 0 && !company.balance"> - </td>
          <td></td>
        </tr>
        <tr>
          <td class="property" translate>company.overview.change-credit</td>
          <td class="value">
            <div class="vox-input-group vox-input-group_dense">
              <input [formControl]="creditInput" class="vox-text-field" name="add-balance" [readonly]="company.readOnly"
                type="number" />
            </div>
          </td>
          <td class="action">
            <button (click)="addCredit()" [disabled]="creditInput.invalid || company.readOnly"
              class="vox-btn btn btn-success" translate>
              company.overview.credit-button
            </button>
          </td>
        </tr>
      </ng-container>
      <!-- end credit  -->
      <!-- kazoo info -->
      <ng-container *ngIf="loadingData.kazooInfo">
        <tr>
          <td colspan="3">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <ngx-skeleton-loader [theme]="{'height': '40px', 'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="!loadingData.kazooInfo">
        <tr>
          <td class="property" translate>company.overview.kazoo-id</td>
          <td class="value">{{company.kazooId}}</td>
          <td></td>
        </tr>
        <tr>
          <td class="property" translate>company.overview.kazoo-instance.title</td>
          <td class="value kazoo" colspan="2">
            <div>
              <b class="mr-1" translate>company.overview.kazoo-instance.id</b>{{kazooInstance}}
            </div>
            <div>
              <b class="mr-1" translate>company.overview.kazoo-instance.link</b> <a *ngIf="linkToKazoo"
                [href]="linkToKazoo" target="_blank" class="vox-btn kazoo-btn">{{linkToKazoo}}</a>
              <span *ngIf="!linkToKazoo"> - </span>
            </div>
          </td>
        </tr>
      </ng-container>
      <!-- end kazoo info -->
      <!-- kazoo lock/unlock -->
      <tr>
        <td class="property" translate>company.overview.kazoo-locked.label</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle placement="left" [disableTooltip]="!company.readOnly" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loadingData.kazooLock" [toggleOn]="kazooLocked" [config]="{isAquamarine: true, disabled: company.readOnly}"
              (toggleOnChange)="lockUnlockKazoo()">
          </vox-toggle>
        </td>
      </tr>
      <!-- end kazoo lock/unlock -->
      <!-- payment verification  -->
      <tr>
        <td class="property" translate>company.overview.payment-verification</td>
        <td class="value"></td>
        <td class="action text-right">
          <vox-toggle placement="left" [disableTooltip]="!company.readOnly && subscription" [ngbTooltip]="'company.overview.disabled-tooltip' | translate" [loading]="loadingData.subscription" [toggleOn]="subscription && subscription?.payment_verification_required" [config]="{isAquamarine: true, disabled: company.readOnly || !subscription}"
            (toggleOnChange)="togglePaymentVerification()">
          </vox-toggle>
        </td>
      </tr>
      <!-- end payment verification  -->
      <!-- start feature flags -->
      <tr>
        <td class="property" translate>company.overview.feature-flags.title</td>
        <td colspan="2" class="value"><gdp-company-feature-flags [company]="company"></gdp-company-feature-flags></td>
      </tr>
      <!-- end feature flags  -->
    </tbody>
  </table>
</div>